(function(global, DS) {
  var ScrollCall = (function() {

    var

    //array with our function calls
    calls = [],

    oldpos = 0;

    call = {
      top : 0,
      bot : 0,
      offsetY : 0,
      onMoveInside : false,
      onEnterHalf: false,
      onLeaveHalf: false,
      onEnter : false,
      onLeave : false,
      isIn : false
    },

    // send in a elem field if needed
    addCall = function(callObj) {
      // if (callObj.selector) {
      //   var obj = DS.$(callObj.selector);
      //   callObj.obj = obj;
      //   calls.push(callObj);
      // }

      // console.log(calls);
      var objs = DS.$$(callObj.selector);
      for (var i = objs.length - 1; i >= 0; i--) {
        var newObj = {};
        for (var k in callObj) {
          newObj[k]=callObj[k];
        }
        newObj.obj = objs[i];
        calls.push(newObj);
      };

      return this;
    },

    //check which calls to perform
    checkScroll = function(e, force) {
      var
      i,
      numOfCalls = calls.length,
      windowY = (window.pageYOffset || document.scrollTop)  - (document.clientTop || 0);
      windowH = window.innerHeight,
      direction = 'down';

      if (windowY < oldpos) {
        direction = 'up';
      }
      oldpos = windowY;

      for ( i = 0; i < numOfCalls; i++) {
        var curr = calls[i];

        var oldIsIn = curr.isIn || false;
        var oldIsFullIn = curr.isFullIn || false;
        var oldIsHalfIn = curr.isHalfIn || false;

        curr.h = curr.obj.offsetHeight;
        curr.top = curr.obj.getBoundingClientRect().top + (curr.offsetY || 0);
        curr.bot = curr.obj.getBoundingClientRect().bottom + (curr.offsetY || 0);

        curr.isIn = (curr.top < windowH) && (curr.bot > 0);
        curr.isFullIn = (curr.top > 0 && curr.top <= windowH) && (curr.bot <= windowH);
        curr.isHalfIn = (curr.top < windowH / 2) && (curr.bot > windowH / 2);

        if (curr.isIn) {
          if (curr.onMoveInside) {
            curr.onMoveInside(curr, direction);
          }
        }
        if (oldIsIn !== curr.isIn || force) {
          if (curr.isIn) {
            if (curr.onEnter) {
              curr.onEnter(curr, direction);
            }
          } else {
            if (curr.onLeave) {
              curr.onLeave(curr.elem, direction);
            }
          }
        }
        if (oldIsFullIn !== curr.isFullIn || force) {
          if (curr.isFullIn) {
            if (curr.onEnterFull) {
              curr.onEnterFull(curr, direction);
            }
          } else {
            if (curr.onLeaveFull) {
              curr.onLeaveFull(curr.elem, direction);
            }
          }
        }
        if (oldIsHalfIn !== curr.isHalfIn || force) {
          if (curr.isHalfIn) {
            if (curr.onEnterHalf) {
              curr.onEnterHalf(curr, direction);
            }
          } else {
            if (curr.onLeaveHalf) {
              curr.onLeaveHalf(curr, direction);
            }
          }
        }
      }
    };

    // add to window scroll listener
    window.addEventListener("scroll", checkScroll);

    return {
      addCall : addCall,
      checkScroll : checkScroll
    };
  })();

  // expose our module to the global object
  global.ScrollCall = ScrollCall;

})(this, DS);
